import axios from "axios";
import { getItem } from "../utils/localStorage";
import { API_URL, MASTER_API_URL, HR_API_URL } from "./constants";
import toast from "react-hot-toast";

const MASTER_API_PREFIXES = ["/user", "/users", "/workspace", "/auth", "/common", "/notification", "/superadmin"];

// Prefix match: exact, sub-path (/prefix/...), hyphenated (/prefix-...), or plural (/prefixs or /prefixs/...).
// The plural form requires end-of-string or `/` after the `s` to avoid false positives.
const matchesPrefix = (path, prefix) =>
  path === prefix ||
  path.startsWith(`${prefix}/`) ||
  path.startsWith(`${prefix}-`) ||
  path === `${prefix}s` ||
  path.startsWith(`${prefix}s/`);

const HR_API_PREFIXES = [
  "/leave",
  "/attendance", "/daily-attendance",
  "/staff", "/salary",
  "/payroll",
  "/reimbursement",
  "/holiday", "/workspace-shift", "/shift",
  "/gate-pass-management", "/gate-tracking",
  "/bank-account", "/quick-link",
  "/team", "/managers",
  "/recruitment",
];

const isAbsoluteUrl = (url) => /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);

const normalizeBaseUrl = (baseUrl) =>
  typeof baseUrl === "string" ? baseUrl.replace(/\/+$/, "") : baseUrl;

const resolveBaseUrlForRequest = (requestUrl) => {
  if (!requestUrl || typeof requestUrl !== "string") return normalizeBaseUrl(API_URL);
  if (isAbsoluteUrl(requestUrl)) return undefined; // already absolute

  const path = requestUrl.startsWith("/") ? requestUrl : `/${requestUrl}`;

  if (MASTER_API_URL && MASTER_API_PREFIXES.some((p) => matchesPrefix(path, p))) {
    return normalizeBaseUrl(MASTER_API_URL);
  }

  if (HR_API_URL && HR_API_PREFIXES.some((p) => matchesPrefix(path, p))) {
    return normalizeBaseUrl(HR_API_URL);
  }

  return normalizeBaseUrl(API_URL);
};

const Axios = axios.create({
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
    "Access-Control-Allow-Origin": "*",
  },
});

// Add a request interceptor
Axios.interceptors.request.use(
  function (config) {
    // Always resolve baseURL dynamically based on the request URL
    const resolvedBaseUrl = resolveBaseUrlForRequest(config.url);
    if (resolvedBaseUrl) {
      config.baseURL = resolvedBaseUrl;
    }

    config.headers = {
      ...config.headers,
      "ngrok-skip-browser-warning": "69420",
      Authorization: `Bearer ${getItem("user")?.token}`,
    };

    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

Axios.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    try {
      // Check if this is a login request (to avoid page reload on login failure)
      // Login failures should be handled by the login component, not by forcing a page reload
      const isLoginRequest = error.config?.url?.includes('/auth/login');
      
      // if (error && error.response && error.response.status === 401 && !isLoginRequest) {
      //   toast.dismiss();
      //   toast.error("Session expired, please login again.");
      //   localStorage.clear();
      //   const currentPath = window.location.pathname + window.location.search;
      //   window.location.href = `/auth/login?redirect=${encodeURIComponent(currentPath)}`;
      // }
    } catch (e) {
      console.error("Error accessing localStorage:", e);
      // Optional: still redirect if something's wrong with storage
      window.location.href = "/auth/login";
    }

    return Promise.reject(error);
  }
);

export default Axios;
